import type { CSSProperties } from "react";
import { t, useLocale } from "@/i18n/locale";

/** CJK and fullwidth glyphs take about 1em; Latin text averages about 0.55em. */
export function estimatedEmWidth(text: string): number {
  let width = 0;
  for (const char of text) width += /[ᄀ-ᇿ⺀-鿿가-힯豈-﫿＀-￯]/u.test(char) ? 1 : 0.55;
  return width;
}

/** `[word]` in a translation marks the word the headline emphasizes. */
export function headlineParts(text: string): { text: string; emphasis: boolean }[] {
  return text.split(/(\[[^\]]+\])/).filter(Boolean).map((part) =>
    part.startsWith("[") && part.endsWith("]") ? { text: part.slice(1, -1), emphasis: true } : { text: part, emphasis: false });
}

/**
 * The hero headline. Its size follows the copy column so the line stays whole
 * where it can (see `--hero-em` in discovery.css); the emphasized word takes
 * the accent color.
 */
export default function HeroHeadline({ message }: { message: string }) {
  useLocale();
  const parts = headlineParts(t(message));
  const plain = parts.map((part) => part.text).join("");
  return (
    <h1 id="discovery-intro-title" style={{ "--hero-em": estimatedEmWidth(plain).toFixed(2) } as CSSProperties}>
      {parts.map((part, index) => part.emphasis
        ? <span key={index} className="discovery-intro-emphasis">{part.text}</span>
        : part.text)}
    </h1>
  );
}
